module.exports = __webpack_public_path__ + "img/placeholder_dark_relationshipmap.05a44c4e.png";